import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "910950d2-73a6-4e9c-8e1e-58578a86234a",
    content: "Sound 1",
    options: { hoverAudioUrl: `${config.ASSETS_URL}/02/08/task/coffee-machine.wav` },
  },
  {
    id: "e862f03a-56e9-4381-9284-377e73d51228",
    content: "Sound 2",
    options: { hoverAudioUrl: `${config.ASSETS_URL}/02/08/task/sports-car-fs.wav` },
  },
  {
    id: "fd1f88a2-1e08-4015-8be1-0aa998f26791",
    content: "Sound 3",
    options: { hoverAudioUrl: `${config.ASSETS_URL}/02/08/task/sports-car-r.wav` },
  },
  {
    id: "269ec36c-0a70-4f1f-b35f-fb5f9ff34984",
    content: "Sound 4",
    options: { hoverAudioUrl: `${config.ASSETS_URL}/02/08/task/steam-train-fs.wav` },
  },
];

const groups = [
  { id: "409b9b24-5ee2-47e8-a918-af82d04f9627", content: "fluctuation strength", options: {} },
  { id: "7c609276-12a2-4aeb-ad92-37ac4279bac9", content: "roughness", options: {} },
];

export const task: Task = {
  id: "20eda05b-ca6a-4fac-a17c-dfe04e235c51",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
    orientation: "vertical",
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "409b9b24-5ee2-47e8-a918-af82d04f9627",
      itemsId: ["e862f03a-56e9-4381-9284-377e73d51228", "269ec36c-0a70-4f1f-b35f-fb5f9ff34984"],
    },
    {
      groupId: "7c609276-12a2-4aeb-ad92-37ac4279bac9",
      itemsId: ["910950d2-73a6-4e9c-8e1e-58578a86234a", "fd1f88a2-1e08-4015-8be1-0aa998f26791"],
    },
  ],
};
